import type { MessageDescriptor } from '@formatjs/intl';
import { createIntl, createIntlCache } from '@formatjs/intl';

import { parseLocale } from '@shieldpay/utility-functions-ui/parse-locale';

import loginMessages from '@shieldpay/i18n/login/en-GB.json';
import onboardingPayeeMessages from '@shieldpay/i18n/onboarding-payee/en-GB.json';
import defaultMessages from '@shieldpay/i18n/shared/en-GB.json';

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();

// Merging all the messages together that will be used to create the intl object
export const messages = {
  ...defaultMessages,
  ...loginMessages,
  ...onboardingPayeeMessages,
};

// Creating the intl shape object that contains all the format* methods
export const intl = (locale = 'en-GB') =>
  createIntl(
    {
      locale,
      messages,
    },
    cache,
  );

export const formatServerMessage = (
  request: Request,
  messageDescriptor: MessageDescriptor,
  values: Record<string, string> = {},
) => {
  const locale = parseLocale(request);

  return intl(locale).formatMessage(messageDescriptor, values);
};
